import React from 'react';
import styles from './styles.module.css';
import { CheckboxButtonType } from './types';

export const CheckboxWithLabel: React.FC<CheckboxButtonType> = ({
  name,
  defaultChecked,
  onChange,
  label,
  description,
  className,
  ...inputProps
}) => {
  return (
    <div className={className}>
      <input
        {...inputProps}
        data-testid="checkbox"
        id={name}
        className={styles.input}
        type="checkbox"
        onChange={onChange}
        defaultChecked={defaultChecked}
      />
      <label
        className={styles.labelContainer}
        htmlFor={name}
        data-testid="label"
      >
        <div className={styles.box} />
        <div className={styles.label}>
          {label}
          {description && (
            <div className={styles.description}>{description}</div>
          )}
        </div>
      </label>
    </div>
  );
};
